<!--<manager-menu-c1-dropdown       *ngIf="type === 'dropdown'"     [type]="type" [wrapper]="wrapper" [menu]="menu" [navigate]="navigate" [dropdown]="dropdown" ></manager-menu-c1-dropdown>-->
@if (!type) {
  <manager-loader-wrapper-global></manager-loader-wrapper-global>
}
@if (type === 'modal') {
  <manager-loader-wrapper-modal [type]="type" [wrapper]="wrapper"></manager-loader-wrapper-modal>
}
@if (type === 'offcanvas') {
  <manager-loader-wrapper-offcanvas [type]="type" [wrapper]="wrapper"></manager-loader-wrapper-offcanvas>
}
@if (type === 'page') {
  <manager-loader-wrapper-page [type]="type" [wrapper]="wrapper"></manager-loader-wrapper-page>
}
